<ngx-spinner bdColor="rgba(0, 0, 0, 0.3)" size="medium" color="#6452c5" type="ball-clip-rotate" [fullScreen]="true">
  <p class="wht-text"> Loading... </p>
</ngx-spinner>
<div class="table-box section">
  <div class="search-wrap section">
    <!-- mrg-search-add -->
    <button class="add-btn" (click)="showModal(content, null, 0)"
      data-testid="teamlist-add-team-button">
      <i class="fa fa-plus-circle"></i> Add team
    </button>
    <span>
      <button class="globlesearchicon" data-testid="teamlist-search-button" (click)="ActiveSearch()" placement="left"
        ngbTooltip="Show/Hide filter" tooltipClass="ngTooltip">
        <i class="fa fa-search"></i>
      </button>
      <div class="search-box" [ngClass]="{ active: IsActiveSearch }">
        <div class="row">
          <div class="col-md-2 col-sm-4 col-6 right">
            <input type="search" (keyup)="RemoveFilter($event)" autocomplete="off" data-testid="teamlist-search-input"
              [(ngModel)]="listingBodyParameter.stSearchText" name="gsearch" class="search client-uni"
              placeholder="search" (keyup.enter)="getTeamDetails()" />
          </div>
        </div>
      </div>
    </span>
  </div>
</div>

<!-- Team listing Starts -->
  <div class="table-box mrgt-acc">
    <div *ngIf="isResponseExist; else NodataElseBlock">
      <mat-accordion>
        <ng-container>
        <mat-expansion-panel (mouseleave)="setClickedRow(-1,isHover,i)" class="acc-panel "
        *ngFor="
        let item of combinedTeamData
        | paginate
        : {
             id: 'pagination2',
             itemsPerPage: listingBodyParameter.inLimit,
             currentPage: listingBodyParameter.inOffset + 1,
             totalItems: totalTeam
            };
        let i = index"
        >
          <mat-expansion-panel-header (click)="onExpansionClick(item.teamId, i)">
            <mat-panel-title class="acc-panel-title-fore-color">
              {{item.name}}<span>&nbsp; &#40;{{item.teamMembersDetails.length}} Users&#41;</span>
            </mat-panel-title>
            <mat-panel-description>
              <span class="dsply-none">{{item.teamId}}</span>
              <div class="team-email-desc txt-cntr" *ngIf="item.email != null">{{getDisplayEmail(item.email)}}</div>
            </mat-panel-description>
          </mat-expansion-panel-header>
  
          <!-- <form [formGroup]="teamForms[i]"> -->
            <div class="container-fluid">
              <div class="team-box">
                <div class="row">
                  
                  <div class="dropdown-container dspl-fxl" id="multi-team">
                    <mat-select data-testid="add-user-team-select" id="teamMemberSelect" [panelClass]="'custom-overlay-panel'" #selectRef  
                          [(value)]="selectedMembers"
                          (openedChange)="onDropdownOpen($event)"
                          multiple
                          class="sel-mat-inp select border-input val-line col-md-3 col-2 client-team-dropd" placeholder="Select team member" [formControl]="item.selectedOptions" (selectionChange)="onSelectionChange($event,item.options)">
                          <mat-option class="mat-search-option teamMember-checkbox" id="search-option" disabled>
                            <input id="searchTeamMemberInput" matInput placeholder="Search team member" autocomplete="off"
                              (keyup)="filterTeamMemberInfo($event, item, i)"
                              (keydown)="onSearchKeydown($event)"
                              class="mat-select-search-input" />
                          </mat-option>
                        
                          <ng-container *ngFor="let teamMember of item.filterTeamMember; trackBy: trackByTeamMember" class="col-md-3 col-2">
                            <mat-option [hidden]="!teamMember.isShow" 
                              [value]="teamMember.teamMemberId">
                                {{ teamMember.teamMemberName }}        
                            </mat-option>
                          </ng-container>
                      </mat-select>
                    <button class="btn-wrap small buttonAdd" (click)="addTeamMember(item.teamId, item.selectedOptions, i)">Add</button>
                  </div>

                  <div class="col-md-2 col-sm-2 col-12 text-right">
                    <div class="actions">
                      <button class="actions-btn wdth-90px"  data-testid="teamlist-action-button" (mouseenter)="setClickedRow(i,isHover,i)" [class.activeheader]="i == selectedRow">
                        <span></span><span></span><span></span>
                      </button>
                      <div class="actions-all-btn">
                        <button id="editTeam" data-testid="teamlist-edit-button" class="btn-wrap small" (click)="onUpdateTeam(content,item.teamId, 1, loCurrentUserData.teamId == item.teamId ? loCurrentUserData.userId : null)">
                          Edit 
                        </button>
                        <button id="historyTeam" class="btn-wrap small" *ngIf="this.loCurrentUserData.isSuperAdmin == true || this.loCurrentUserData.IsHistoryAccess == true"
                        (click)="getTeamHistory(item.teamId)" data-testid="teamlist-history-button">
                          History
                        </button>
                        <button id="archiveTeam" 
                        data-testid="teamlist-archive-button" class="btn-wrap red-btn small"  (click)="showArchiveAlert(contentArchive,item.teamId)" >
                          Archive
                        </button> 
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 col-sm-12 col-12" 
                       *ngFor="let child of item.teamMembersDetails; let indexOfelement=index">
                    <div class="team">
                      <div class="text">
                        <div class="img">
                          <img [src]="child.stProfileImageURL">
                        </div>
                        <div class="box">
                          <h5>{{child.name}}</h5>
                          <h6>{{child.role}}</h6>
                        </div>
                      </div>
                      <button type="button" class="btn-wrap red-btn small" data-testid="teamlist-remove-button"
                              (click)="removeTeamMember(child.userId, item.teamId)">Remove</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          <!-- </form> -->
        </mat-expansion-panel>
      </ng-container>
      </mat-accordion>
    </div>
  

    <ng-template #NodataElseBlock>
      <div>
        <p class="no-data-avbl">
          No data available
        </p>
      </div>
    </ng-template>
  

  <ng-template #NodataElseBlock>
    <div>
      <p class="no-data-avbl">
        {{LoadingDataMessage}}</p>
    </div>
  </ng-template>
</div>
<!-- Team listing Ends -->


<!-- Modal - Add/Edit Team Starts -->
<ng-template #content let-modal>
  <div class="modal-header ">
    <h5 class="modal-title">Add/Edit team</h5>
    <button type="button " class="close close-icon" data-testid="teamlist-close-button" aria-label="Close "
      (click)="modal.dismiss( 'Cross click') ">
      <span aria-hidden="true "><img src="../../../../../assets/images/close.svg " /></span>
    </button>
  </div>
  <div class="modal-body mdl-bg-clr">
    <app-addteams [teamId]="teamId" [UserIdForUpdateTeamHeader]="UserIdForUpdateTeamHeader"
      [teamMembers]="userByEmailResponse"  [inReportTypeClient]="inReportTypeClient"
      [inPriorityClient]="inPriorityClient" (webPageToggle)="onWebPageToggle($event)"
      [inTurnaroundTimeClient]="inTurnaroundTimeClient" [stReportTypesClient]="stReportTypesClient"
      [flgIsEmailOnPublishClient]="flgIsEmailOnPublishClient"></app-addteams>
  </div>
</ng-template>
<!-- Modal - Add/Edit Team Ends -->


<!-- Modal - Archive Starts -->
<ng-template #contentArchive let-modal>
  <div class="modal-header ">
    <h6 class="modal-title text-center archive-header-title" id="modal-basic-title">Alert</h6>
    <button type="button " data-testid="teamlist-alert-button" class="close close-icon" aria-label="Close "
      (click)="modal.dismiss( 'Cross click') ">
      <span aria-hidden="true "><img src="../../../../../assets/images/close.svg " /></span>
    </button>
  </div>
  <div class="modal-body text-center">
    <span class="archive-content"> Are you sure you want to archive this team? </span>
    <button type="button" data-testid="teamlist-alert-archive-button" class="btn-wrap btn-box red-btn archive-btn"
      (click)="archive(teamId)">Archive</button>
  </div>
</ng-template>
<!-- Modal - Archive Ends -->